import { render } from "./Age.vue?vue&type=template&id=a3d4fad6&scoped=true"
import script from "./Age.vue?vue&type=script&lang=js"
export * from "./Age.vue?vue&type=script&lang=js"

import "./Age.vue?vue&type=style&index=0&id=a3d4fad6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3d4fad6"]])

export default __exports__